/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useAuth } from '../context/AuthContext';

function Header() {
    const { logout } = useAuth();
    const handleLogout = () => {
        logout(); // Use context logout to update state and redirect
    };
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary mb-4">
            <div className="container-fluid">
                <Link className="navbar-brand" to="/customers">
                    <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Logo" height="40" style={{ maxHeight: 40 }} />
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <Link className="nav-link" to="/customers">Customers</Link>
                        </li>
                        {/* <li className="nav-item">
                            <Link className="nav-link" to="/logs">Logs</Link>
                        </li> */}
                    </ul>
                    <button className="btn btn-outline-light" title='Logout' onClick={handleLogout}><i class="fa-solid fa-power-off"></i></button>
                </div>
            </div>
        </nav>
    );
}

export default Header;
